<template>
  <div>
    <stickyNav v-if="enableStickyNav" />

    <section class="enterprise-bg">
      <div class="container shape-container">
        <div class="py-5">
          <div class="col-lg-8 py-5">
            <div class="row pt-5">
              <h3 class="display-3 mt-5">
                Enterprise: Power Your Own Digital Services Platform
              </h3>

              <p class="lead text-dark">
                TopupBox Enterprise is a Platform-as-a-Service that empowers
                dealers, MNO partners, and merchants to aggregate products,
                build their own platforms, and provide API services, all under
                their own brand.
              </p>

              <div class="btn-wrapper">
                <router-link to="/register" class="btn btn-info">
                  Apply as a dealer
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="pb-5 px-lg-0 px-4">
      <div class="container">
        <div class="text-center justify-content-center">
          <div class="col-lg-12">
            <h2 class="display-3 text-dark">Who It’s For</h2>

            <p class="lead mb-5">Built for Dealers, Partners & Aggregators</p>
          </div>
        </div>

        <div class="row row-grid align-items-center pb-md-5">
          <div class="col-md-5 order-md-2" data-aos="fade-left" data-aos-easing="ease-out-cubic"
            data-aos-duration="1000">
            <div class="pl-md-5">
              <div class="mb-4">
                <img src="img/icons/common/enterprise.svg" class="img-fluid" />
              </div>

              <p class="default">
                Whether you’re a telco dealer, merchant, or MNO partner,
                Enterprise gives you the infrastructure to run your own digital
                services business - not just resell, but own the platform your
                customers use.
              </p>
            </div>
          </div>

          <div class="col-md-6 order-md-1">
            <img src="img/theme/two-people.png" class="img-fluid rounded shadow-lg floating" />
          </div>
        </div>

        <div class="row row-grid align-items-center pb-md-5">
          <div class="col-lg-12 text-center">
            <h2 class="display-3 text-dark">Why Enterprise</h2>

            <p class="lead mb-5">More Than Reselling - Run Your Own Platform</p>
          </div>

          <div class="col-md-6 order-md-2">
            <img src="img/theme/build.png" class="img-fluid rounded shadow-lg floating" />
          </div>

          <div class="col-md-6 order-md-1" data-aos="fade-right" data-aos-easing="ease-out-cubic"
            data-aos-duration="1000">
            <div class="pr-md-5">
              <div class="mb-4">
                <img src="img/icons/common/pen.svg" class="img-fluid" />
              </div>

              <p class="lead">Enterprise lets you scale like an aggregator:</p>
              <div class="lead">
                <div class="d-flex align-items-center">
                  <badge type="primary" circle class="mr-3" icon="ni ni-check-bold"></badge>
                  <p class="display-4 lead mb-0">
                    Aggregate airtime, data, and utility services in one place
                  </p>
                </div>
                <div class="d-flex align-items-center">
                  <badge type="primary" circle class="mr-3" icon="ni ni-check-bold"></badge>
                  <p class="display-4 lead mb-0">
                    Launch your own branded platform with ease
                  </p>
                </div>
                <div class="d-flex align-items-center">
                  <badge type="primary" circle class="mr-3" icon="ni ni-check-bold"></badge>
                  <p class="display-4 lead mb-0">
                    Provide API access to your customers for seamless
                    integration
                  </p>
                </div>
                <div class="d-flex align-items-center">
                  <badge type="primary" circle class="mr-3" icon="ni ni-check-bold"></badge>
                  <p class="display-4 lead mb-0">
                    Earn more while staying in control of your business
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="values-section pb-5 pt-lg-0 px-lg-0 px-4">
      <div class="container">
        <div class="container pt-lg">
          <div class="row text-center justify-content-center">
            <div class="col-lg-10">
              <h2 class="display-3 text-dark">Features</h2>
              <p class="lead text-dark">Everything You Need to Scale</p>
            </div>
          </div>

          <div class="row row-grid mt-5 text-center">
            <!-- branded business -->
            <div class="col-lg-3">
              <div class="mb-4">
                <i class="ni ni-shop text-primary display-3"></i>
              </div>

              <h5 class="text-dark mt-3">Branded Business Platform</h5>

              <p class="mt-3 lead-2">
                Manage all customer transactions on your own
              </p>
            </div>
            <!-- airtime and data -->
            <div class="col-lg-3">
              <div class="mb-4">
                <i class="ni ni-mobile-button text-primary display-3"></i>
              </div>

              <h5 class="text-dark mt-3">Airtime & Data Aggregation</h5>

              <p class="mt-3 lead-2">
                Deliver instant access to airtime and data bundles.
              </p>
            </div>
            <!-- utility -->
            <div class="col-lg-3">
              <div class="mb-4">
                <i class="ni ni-credit-card text-primary display-3"></i>
              </div>

              <h5 class="text-dark mt-3">Utility and Bills Payment</h5>

              <p class="mt-3 lead-2">
                Be the one-stop solution for electricity, TV, and more.
              </p>
            </div>
            <!-- api -->
            <div class="col-lg-3">
              <div class="mb-4">
                <i class="ni ni-settings-gear-65 text-primary display-3"></i>
              </div>

              <h5 class="text-dark mt-3">Robust APIs</h5>

              <p class="mt-3 lead-2">
                Give your customers direct integration with fully documented
                developer tools.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-white pt-md-5 my-5 px-lg-0 px-4">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 pr-lg-5">
            <img src="img/theme/developer.jpeg" class="img-fluid rounded shadow-lg floating" />
          </div>

          <div class="col-md-6">
            <div class="pl-lg-5">
              <div class="mb-4">
                <i class="ni ni-laptop text-primary display-1"></i>
              </div>

              <h3>Developer-Friendly APIs</h3>

              <p class="lead my-2">APIs That Power Your Growth</p>

              <p>
                Our APIs are fully documented and easy to integrate, helping you
                build, test, and deploy applications faster. With Enterprise,
                you can extend your services to developers, partners, and
                customers without complexity.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import StickyNav from "../layout/StickyHeader";
export default {
  name: "enterprise",
  components: { StickyNav },
  data() {
    return { enableStickyNav: null, code: "" };
  },
  mounted() {
    window.addEventListener("scroll", this.handleNavDisplay);
  },
  destroyed() {
    window.addEventListener("scroll", this.handleNavDisplay);
  },
  methods: {
    handleNavDisplay() {
      var y = window.scrollY;
      if (y > 100 && !this.enableStickyNav) {
        this.enableStickyNav = true;
      } else if (y < 100 && this.enableStickyNav) {
        this.enableStickyNav = false;
      }
    },
  },
};
</script>
